export const UPDATE_CURRENT_SCENARIO = 'SCENARIO:UPDATE_CURRENT_SCENARIO';
export const CURRENT_SCENARIO_UPDATED = 'SCENARIO:CURRENT_SCENARIO_UPDATED';